import React, {useRef, useState, useEffect} from "react";

import CounterCard from "../counterCard/CounterCard";
import {getTimeRemaining} from "./components/getTimeRemaining";

import styles from './Counter.module.scss';

function Counter() {

    const countdown = useRef(new Date("2025-10-01T00:00:00"));

    const [time, setTime] = useState(getTimeRemaining(countdown.current));

    useEffect(() => {
        const interval = setInterval(() => {
            const t = getTimeRemaining(countdown.current);
            if (t.diff <= 0) clearInterval(interval);
            setTime(t);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const getTime = (time: number) => {
        return Number(time) <= 9 ? `0${time}` : time;
    }

    return (
        <div className={styles.cards}>
            <div className={styles.card}>
                <CounterCard time={getTime(time.days)}/>
                <p className={styles.cardLabel}>Дни</p>
            </div>
            <div className={styles.card}>
                <CounterCard time={getTime(time.hours)}/>
                <p className={styles.cardLabel}>Часы</p>
            </div>
            <div className={styles.card}>
                <CounterCard time={getTime(time.minutes)}/>
                <p className={styles.cardLabel}>Минуты</p>
            </div>
            <div  className={styles.card}>
                <CounterCard time={getTime(time.seconds)}/>
                <p className={styles.cardLabel}>Секунды</p>
            </div>
        </div>
    );
}

export default Counter;
